// export const url = 'http://localhost:8081/hangKnife'
export const url = 'https://www.hangknife.com/api'   // 香港服务器


export const OauthUrl = 'https://hangknife.com/oauthServer'
export const SteamNodeUrl = "http://localhost:3000"
// export const SteamNodeUrl = "https://www.hangknife.com/oauthNode"



// WEBPACK FOOTER //
// ./src/api/url.js